import { Pipe, PipeTransform } from '@angular/core';
import { ErrorCode } from '@app-types/enums/error-code';

@Pipe({
  name: 'formatMessageImportEml',
  standalone: true,
})
export class FormatMessageImportEmlPipe implements PipeTransform {
  transform(state: ErrorCode): string {
    switch (state) {
      case ErrorCode.ValidationError:
        return 'importEmlValidationError';
      case ErrorCode.ImportEmlTempPathNotConfigured:
        return 'importEmlTempPathNotConfigured';
      case ErrorCode.UnknownFileType:
        return 'importEmlUnknownFileType';
      case ErrorCode.EntityDoesNotExists:
        return 'importEntityDoesNotExists';
      case ErrorCode.ImailBuildError:
        return 'importEmlImailBuildError';
      case ErrorCode.EmailExistsByHash:
        return 'importEmlEmailExistsByHash';
      case ErrorCode.InvalidFolder:
        return 'importEmlInvalidFolder';
      case ErrorCode.MailAccountDontExist:
        return 'importEmlMailAccountDontExist';
      case ErrorCode.ExtractFileError:
        return 'importEmlExtractFileError';
      case ErrorCode.UnhandledError:
        return 'importEmlUnhandledError';
      case ErrorCode.AntiEnumerationConvert:
        return 'errorAntiEnumerationConvert';
      default:
        return '';
    }
  }
}
